import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import CompanionConfigVersion from './CompanionConfigVersion';
import { initialCompanionConfigVersionState } from '../../reducers/initialState';
import { getCompanionConfigVersionManager, getUserProfileWidget, getModelManager } from '../../selectors/index';
import {
  postCompanionConfigVersionThunk,
  describeCompanionConfigVersionThunk,
  changeCompanionConfigVersion,
  resetCompanionConfigVersionStatus
} from '../../actions/companionConfigVersion';

const mapStateToProps = state => {
  return {
    companionConfigVersionManager: getCompanionConfigVersionManager(state) || {
      ...initialCompanionConfigVersionState.companionConfigVersionManager
    },
    userProfileWidgets: getUserProfileWidget(state),
    modelManager: getModelManager(state)
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      saveCompanionConfigVersion: (companionConfigVersion, widgetCode) =>
        postCompanionConfigVersionThunk(companionConfigVersion, widgetCode),
      describeCompanionConfigVersion: (modelCompanionConfigVersionId, widgetCode) =>
        describeCompanionConfigVersionThunk(modelCompanionConfigVersionId, widgetCode),
      changeCompanionConfigVersion: selectedCompanionConfigVersion => changeCompanionConfigVersion(selectedCompanionConfigVersion),
      resetCompanionConfigVersionStatus: () => resetCompanionConfigVersionStatus()
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(CompanionConfigVersion);
